import ApiService from './ApiService.js';
import moment from 'moment'
const uuidv1 = require('uuid/v1');
const querystring = require('querystring')
var DashboardService = {
    getStyleLookup:function($data) {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="styleLookupAts?"+querystring.stringify($data)
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                   resolve(response.data)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    getInventory:function($data) {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="inventoryLookupAts?"+querystring.stringify($data)
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                   resolve(response.data)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    getInventorybySeason:function($data) {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="inventorySeasonAts?"+querystring.stringify($data)
            $options.method="get"
            ApiService.request($options)
                .then(response => {
                   resolve(response.data)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    getMonthlySales:function() {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="monthlySales"
            $options.method="get"
            
            ApiService.request($options)
                .then(response => {
                   resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });
    },
    getOrdersInDue:async function() {
        return new Promise(async function(resolve,reject) {
            var $options= {};
            $options.url ="ordersDue"
            $options.method="get"
            
            ApiService.request($options)
                .then(response => {
                   resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },

    getWeeklySales:function() {
            return new Promise(function(resolve,reject) {
                var $options= {};
                $options.url ="weeklySales"
                $options.method="get"
                
                ApiService.request($options)
                    .then(response => {
                       resolve(response.data.data)
                    }).catch(error=> {
                        reject(error);
                    })
            });

    },
    getData:function($url) {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url =$url
            $options.method="get"
            
            ApiService.request($options)
                .then(response => {
                   resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

}
};
export default DashboardService;
